import React from 'react';

const AccountsPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default AccountsPage;
